<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="19.5" height="21.5" viewBox="0 0 19.5 21.5">
    <g transform="translate(-1634.25 -748.25)">
      <path :style="{stroke:color}" class="a" d="M3,6H21" transform="translate(1632 747)"/>
      <path :style="{stroke:color}" class="a" d="M19,6V20a2,2,0,0,1-2,2H7a2,2,0,0,1-2-2V6M8,6V4a2,2,0,0,1,2-2h4a2,2,0,0,1,2,2V6"
            transform="translate(1632 747)"/>
      <line :style="{stroke:color}" class="b" y2="6" transform="translate(1642 758)"/>
      <line :style="{stroke:color}" class="b" y2="6" transform="translate(1646 758)"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: "DeleteIcon",
  props: {
    color: String
  }
}
</script>

<style scoped>
.a {
  fill: rgba(255, 255, 255, 0);
}

.a, .b {
  stroke: #57b98f;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.5px;
}

.b {
  fill: none;
}
</style>
